import type {DiffLine, DiffLineSelectionInfo, DiffLineWithSelectionInfo} from '../types'
import {useDiffStore} from './DiffStore'
import {diffLineKey} from './slices/helpers/diff-lines-slice-helpers'

// State selectors
export const useGetSplitDiffLinesFromLineRange = () => useDiffStore(s => s.diffLines.getSplitDiffLinesFromLineRange)

export const useGetSelectedDiffLines = () => useDiffStore(s => s.diffLines.getSelectedDiffLines)

export const useGetDiffLinesInfo = () => useDiffStore(s => s.diffLines.getDiffLinesInfo)

export const useGetFirstLineSelectionOnDrag = () => useDiffStore(s => s.diffLines.getfirstLineSelectionOnDrag)

export const useGetSelectedLineRange = () => useDiffStore(s => s.diffLines.getSelectedLineRange)

export const useHasSelectedLines = () => useDiffStore(s => s.diffLines.hasSelectedLines)

export const useDialogModeIsEnabled = (gridCellId: string | undefined) =>
  useDiffStore(s => {
    if (!gridCellId) return false
    return s.dialogMode.activeGridCellId === gridCellId
  })

export const useDialogModeActions = () => useDiffStore(s => s.dialogModeActions)

export const useDiffAnchor = () => useDiffStore(s => s.diffLines.diffAnchor)

export const useFileLineCount = () => useDiffStore(s => s.diffLines.fileLineCount)

const UNSELECTED_LINE: DiffLineSelectionInfo = {
  isSelected: false,
  isFirstSelected: false,
  isLastSelected: false,
}

export const useDiffLineSelectionInfo = (diffLine?: DiffLine | DiffLineWithSelectionInfo | undefined) =>
  useDiffStore(s => {
    if (!diffLine) return UNSELECTED_LINE

    return s.diffLines.selectedLinesInfo[diffLineKey(diffLine)] || UNSELECTED_LINE
  })

// Actions selectors
export const useDiffLinesActions = () => useDiffStore(s => s.diffLinesActions)

export const useInjectedContextLinesActions = () => useDiffStore(s => s.injectedContextLinesActions)

export const useTreeEntries = () => useDiffStore(s => s.treeEntries)
